export class Agency {
  public id: number;
  public ministryId: number;
  public agencyName: string;

  public remarks: string;

  public ministryName : string;
  public activeStatus : string;

  public pageNumber : number;
  public pageSize : number;
  public sortingKey: String;
  public sortingValue: String;



  constructor() {}
}
